import {invoker} from 'ramda';

export default invoker(2, 'addEventListener');
